import { useQuery } from 'react-query';
import { taxonService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useFetchPromotedTaxons = () => {
  return useQuery(
    `${ServerStateKeysEnum.promotedTaxons}`,
    () => {
      return taxonService.getPromotedTaxons();
    },
    {
      staleTime: Infinity,
    }
  );
};
